const Result=require('./result');

function Ok(data){
  Result.call(this,data,undefined);
}
Ok.prototype = Object.create(Result.prototype);
module.exports=Ok;